import { Star, Quote } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

function Card({ name, city, text }) {
  return (
    <div className="w-[300px] md:w-[360px] shrink-0 mx-3 bg-paper border border-line rounded-2xl p-6 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex gap-0.5 text-brand">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={15} className="fill-brand" strokeWidth={0} />
          ))}
        </div>
        <Quote size={22} className="text-brand/25" />
      </div>
      <p className="mt-4 text-sm text-ink/85 leading-relaxed">{text}</p>
      <div className="mt-5 flex items-center gap-3">
        <span className="h-9 w-9 rounded-full bg-brand/10 text-brand font-semibold text-sm flex items-center justify-center">
          {name.charAt(0)}
        </span>
        <div className="leading-tight">
          <div className="text-sm font-semibold">{name}</div>
          <div className="text-xs text-stone">{city}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { t } = useLang();
  const { overline, title, items } = t.testimonials;

  return (
    <section className="bg-mist py-20 md:py-28 border-t border-line overflow-hidden" data-testid="testimonials">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal className="text-center">
          <div className="flex justify-center"><Overline>{overline}</Overline></div>
          <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.08]">
            {title}
          </h2>
        </Reveal>
      </div>

      <div className="mt-12 relative">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-mist to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-mist to-transparent z-10" />
        <div className="marquee-track hover:[animation-play-state:paused]">
          {[0, 1].map((dup) => (
            <div key={dup} className="flex shrink-0" aria-hidden={dup === 1}>
              {items.map((it, i) => (
                <Card key={`${dup}-${i}`} name={it.name} city={it.city} text={it.text} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
